import React, { useContext } from 'react'
import { AuthContext } from '../../providers/Auth'

const useAuth = () => {
  return useContext(AuthContext)
}

export default useAuth
